
import { Project, Review, SiteConfig, ProcessStep, FAQItem, Statistic, TechItem, Service } from './types';

/**
 * =============================================================================
 * ZIVUSH PORTFOLIO CONTENT CONFIGURATION
 * =============================================================================
 * Edit this file to change website content. No admin login required.
 */

export const SITE_CONFIG: SiteConfig = {
  email: 'ziv.public25@gmail.com',
  discordHandle: 'zivush__',
  discordInvite: 'https://discord.gg/A2aQwK5WGP',
  githubUrl: 'https://github.com/Zivush1',
  spigotUrl: 'https://www.spigotmc.org/resources/authors/zivthemagniv.1183586/',
  builtByBitUrl: 'https://builtbybit.com/members/zivush.531479/',
};

export const STATISTICS: Statistic[] = [
  { id: '1', value: '3+', label: 'Years Experience' },
  { id: '2', value: '100+', label: 'Commissions' },
  { id: '3', value: '100%', label: 'Satisfaction Rate' },
];

export const TECH_STACK: TechItem[] = [
  { name: 'Java', color: '#ef4444' },
  { name: 'Spigot API', color: '#fb923c' },
  { name: 'Paper', color: '#f87171' },
  { name: 'Velocity', color: '#3b82f6' },
  { name: 'Redis', color: '#dc2626' },
  { name: 'MongoDB', color: '#4ade80' },
  { name: 'MySQL', color: '#60a5fa' },
  { name: 'Gradle', color: '#22d3ee' },
  { name: 'Maven', color: '#a855f7' },
  { name: 'Git', color: '#fca5a5' },
];

export const SERVICES: Service[] = [
  {
    id: '1',
    title: 'Minigame Engines',
    description: 'Robust, state-managed minigame cores with multi-arena support, lobby handling, and zero-flicker scoreboards.',
    iconName: 'Gamepad2',
    iconColorClass: 'text-mc-blue',
  },
  {
    id: '2',
    title: 'Interactive GUIs',
    description: 'Complex inventory menus with animations, pagination, and responsive user interaction.',
    iconName: 'Layout',
    iconColorClass: 'text-purple-500',
  },
  {
    id: '3',
    title: 'Particles & Abilities',
    description: 'Visual prowess using particles for custom class abilities, magic spells, and cosmetics.',
    iconName: 'Sparkles',
    iconColorClass: 'text-yellow-400',
  },
  {
    id: '4',
    title: 'Data Persistence',
    description: 'Fully configurable storage solutions supporting MySQL, SQLite, and YAML flatfiles for cross-server sync.',
    iconName: 'Database',
    iconColorClass: 'text-cyan-400',
  },
];

export const PROCESS_STEPS: ProcessStep[] = [
  {
    id: '1',
    title: 'Consultation',
    description: 'We discuss your idea, requirements, and server version. I provide a feasibility check and a price quote.',
    iconName: 'MessageSquare',
  },
  {
    id: '2',
    title: 'Development',
    description: 'Update frequency depends on project size (e.g., halfway vs. completion). You can also join a test server to preview features upon request.',
    iconName: 'FileCode2',
  },
  {
    id: '3',
    title: 'Testing & QA',
    description: 'I test thoroughly, though complex logic may require live-environment testing. Any bugs found in the initial delivery will be fixed immediately.',
    iconName: 'ShieldCheck',
  },
  {
    id: '4',
    title: 'Delivery & Support',
    description: 'Includes at least 30 days of bug-fix support. I sometimes add small extra requests for free shortly after delivery, but this is not guaranteed.',
    iconName: 'Rocket',
  },
];

export const FAQS: FAQItem[] = [
  {
    question: "Do you provide the source code?",
    answer: "Yes! For custom commissions, you can request the source code for an additional fee. This allows your future developers to maintain it."
  },
  {
    question: "What payment methods do you accept?",
    answer: "I accept only PayPal. For orders over $10, you can choose to pay 50% upfront and 50% upon completion. Smaller orders (<$10) require full payment upfront."
  },
  {
    question: "Can you update my old plugin?",
    answer: "It depends on the complexity. If the code is clean, yes. If it's 'spaghetti code', it is often cheaper and better to rewrite it from scratch."
  },
  {
    question: "What versions do you support?",
    answer: "I support all versions from 1.8.8 to the latest 1.21+. I highly recommend Paper or Purpur forks for the best performance."
  }
];

export const REVIEWS: Review[] = [
  {
    id: '1',
    author: 'pepsiisgross',
    rating: 5,
    text: "Zivush made me a plugin that was exactly what I wanted. He made all the changes I requested and added extra features I hadn't even thought of. There were definitely some things where I felt I was asking way too much for the prices he charge, but he didn't mind. Zivush was super nice, communicative, and great throughout the whole process. I'll definitely be working with him mor ein the future with other needs!",
    proofUrl: 'https://www.spigotmc.org/threads/%E2%9C%85-custom-minecraft-plugins-%E2%80%93-fast-affordable-trusted-100-happy-clients.659179/page-2'
  },
  {
    id: '2',
    author: 'Fadez',
    rating: 5,
    text: "I've had Two Plugins Developed by Zivush So Far, And I will defiantly be back for more. If you are looking for affordable plugin development, excellent service, with quick Turnaround times, look no further Zivush is your man!",
    proofUrl: 'https://www.spigotmc.org/attachments/upload_2024-8-31_12-31-58-png.850724/'
  },
  {
    id: '3',
    author: 'RTX',
    rating: 5,
    text: "10/10 Delivery: 10/10 Communication: 20/10 Plugin: 20/10",
    proofUrl: 'https://www.spigotmc.org/attachments/upload_2024-8-18_0-33-10-png.848136/'
  },
  {
    id: '4',
    author: 'hydra',
    rating: 5,
    text: "Zivush was very fast and responsible guy! I would recommend this person to everyone because he's very affordable!",
    proofUrl: 'https://www.spigotmc.org/attachments/upload_2024-8-28_22-24-7-png.850148/'
  },
    {
    id: '5',
    author: 'Zlyjulian',
    rating: 5,
    text: "I had a fantastic experience working with Zivush who created three plugins for my Minecraft server: AFKZone, TimeCoins, and Tokens. He delivered all the plugins quickly, which was important due to my servers tight deadline and he also provided excellent support with setting up the configurations. After delivering the final versions, he made some requested changes within minutes. Highly recommended!",
    proofUrl: 'https://www.spigotmc.org/attachments/upload_2024-10-10_13-5-12-png.857406/'
  },
    {
    id: '6',
    author: 'itsSauros',
    rating: 5,
    text: "As Legacy of Sauros, we had the global chat plugin made by Zivush. Support: 10/10 Performance: 10/10 Friendly: 10/10",
    proofUrl: 'https://www.spigotmc.org/attachments/upload_2024-8-31_15-56-43-png.850770/'
  },
    {
    id: '7',
    author: 'Blaze439',
    rating: 5,
    text: "Zivush is a amazing plugin maker, everything I asked him, he was able to make it with out issues and the small issues he did have was just simply because he needed more info from me to finish the plugin about how i wanted it be made. I asked him to make a plugin with the commands /spawn, /sethome /home, /playtime, /delhome, /wild, /buy(he even set up my shop for me), and playtime counter for each player! When he finished the plugin there was like 2 things not working after i installed it to my server but after notifying Zivush of the 2 issues it took him less then 3 mintes to fix it. My rating would be 10/5. The speed of this man when it comes to coding is insane! This plugin was created with in (How long it took you). Amazing work! Already hired him for an other project I needed done for my server in mc!",
    proofUrl: 'https://www.spigotmc.org/attachments/upload_2024-10-1_9-59-54-png.855990/'
  },
    {
    id: '8',
    author: 'xBengie',
    rating: 5,
    text: "I ordered a custom Velocity plugin. The order was delivered a few hours later and meets expectations. They even thought ahead by adding an extra function that is very useful. Friendly and clear in his communication and very good price/quality ratio. If I need any more custom plugins in the future, I will contact him again.",
    proofUrl: 'https://imgur.com/mNzqY2R'
  },
    {
    id: '9',
    author: 'Mali',
    rating: 5,
    text: "Really nice plugin clean gui all round exactly what I asked for, really nice dev as well always happy to help out and just an all round great guy. If you need something done 10/10 recommended.",
    proofUrl: 'https://www.spigotmc.org/attachments/upload_2024-10-14_23-47-57-png.858086/'
  },
  {
    id: '10',
    author: 'Carrysav',
    rating: 5,
    text: "great developer, he made me a high quality plugin in a short time and low price, recommend!",
    proofUrl: 'https://www.spigotmc.org/attachments/upload_2024-9-8_15-28-13-png.852242/'
  },
  {
    id: '11',
    author: 'dr_maxi',
    rating: 5,
    text: "I needed a very simple plugin so i turned to Zivush and after he saw my request he started working on it immeditly. After an hour he was done. There was no problem with my plugin. Fast delivery and it was very affordable. I may come back when i need an another plugin.",
    proofUrl: 'https://www.spigotmc.org/attachments/upload_2024-9-9_11-29-58-png.852406/'
  },
  {
    id: '12',
    author: 'PixelPunk',
    rating: 5,
    text: "Zivush did an awesome job creating a custom mc plugin for me. The price was super reasonable, and he finished it way faster than I expected. he was really friendly throughout the whole process and kept me updated. The plugin works great and adds exactly what I wanted to my server. Definitely recommend Zivush if you need any plugin!",
    proofUrl: 'https://www.spigotmc.org/attachments/upload_2024-9-26_17-14-14-png.855137/'
  },
  {
    id: '13',
    author: '𝖄𝖔𝖚𝖗𝕹𝖔𝖙𝕷𝖚𝖎𝖘',
    rating: 5,
    text: "Fast, to the point and responds Perfectly to Feedback and Plugin Improvements! 11/10 would definetly reccomend. any kind of Suggestion I brought up was added and if there was miscommunication he would ask if he understood right instead of just doing what he though, best plugin dev I have worked with so far - Cope Events",
    proofUrl: 'https://www.spigotmc.org/attachments/upload_2024-10-7_13-19-2-png.856915/'
  },
  {
    id: '14',
    author: 'Wayz',
    rating: 5,
    text: "Zivush created a custom hoes plugin for me It was v affordable and he made sure everything worked, great support!! Also included good config with levels, boosters and more.",
    proofUrl: 'https://www.spigotmc.org/attachments/upload_2024-8-15_12-57-39-png.847565/'
  },
  {
    id: '15',
    author: 'yepikaiye',
    rating: 5,
    text: "fast delivery + 10/10 quality, would recommend",
    proofUrl: 'https://imgur.com/ItUkmVH'
  },
    {
    id: '16',
    author: 'Sloth',
    rating: 5,
    text: "Very fast services! Affordable! Helped me with errors on my end as well! highly recommend!",
    proofUrl: 'https://www.spigotmc.org/attachments/upload_2024-10-20_21-55-7-png.859050/'
  },
  {
    id: '17',
    author: 'Kallus',
    rating: 5,
    text: "He was fast and understood my project very quickly. If I needed some changes, he made them without questions to satisfy me. 5/5, no questions asked",
    proofUrl: 'https://www.spigotmc.org/attachments/upload_2024-10-23_20-32-1-png.859489/'
  },
  {
    id: '18',
    author: 'Evymocdorr',
    rating: 5,
    text: "Zivush is a great guy and a top-notch plugin developer—10/10! Delivery: 10/10 Plugin Quality: 10/10 Friendly 100/10",
    proofUrl: 'https://www.spigotmc.org/attachments/upload_2024-11-2_18-18-4-png.861241/'
  },
    {
    id: '19',
    author: 'Keepahh',
    rating: 5,
    text: "Delivery: 11/10 nCommunication: 10/10 Plugin 11/10 Nice and fast easy to understand fine config. Not much to complain about well done!",
    proofUrl: 'https://www.spigotmc.org/attachments/upload_2024-10-11_14-37-41-png.857535/'
  }
];

/**
 * HOW TO ADD IMAGES / VIDEOS:
 * 1. External URL: Paste a link from Imgur, Unsplash, or a direct website link.
 * 2. Local File (Images OR Videos): 
 *    - Create a folder named 'public' in your project root.
 *    - Save your file there (e.g., 'my-video.mp4' or 'screenshot.png').
 *    - Set mediaUrl to: 'my-video.mp4' (WITHOUT the / slash at start)
 *    - IMPORTANT: If it's a video, set mediaType to 'video'.
 * 3. YouTube: Paste the full YouTube video URL (e.g. https://www.youtube.com/watch?v=...)
 *    Ensure mediaType is set to 'video'.
 */
export const PROJECTS: Project[] = [
  {
    id: '1',
    title: 'UltimatePlayerWorldEdit ',
    description: 'UltimatePlayerWorldEdit brings controlled WorldEdit-style editing directly to players, with custom wands, block storage, upgrades, and advanced building tools built from scratch it is one of my most complex and time-intensive projects, showcasing my plugin architecture skills.',
    tags: [],
    mediaType: 'video',
    mediaUrl: 'https://www.youtube.com/watch?v=Zoj8omowU8M',
    linkUrl: '#',
  },
  {
    id: '2',
    title: '',
    description: '',
    tags: [],
    mediaType: 'video',
    mediaUrl: 'https://i.imgur.com/iFwTzJD.mp4',
    linkUrl: '#',
  },
  {
    id: '3',
    title: '',
    description: '',
    tags: [],
    mediaType: 'video',
    mediaUrl: 'https://i.imgur.com/fz0BsnT.mp4',
    linkUrl: '#',
  },
  {
    id: '4',
    title: '',
    description: '',
    tags: [],
    mediaType: 'video',
    mediaUrl: 'https://i.imgur.com/iOzBJU2.mp4',
    linkUrl: '#',
  },
  {
    id: '5',
    title: '',
    description: '',
    tags: [],
    mediaType: 'video',
    mediaUrl: 'https://i.imgur.com/DspMwHi.mp4',
    linkUrl: '#',
  },
  {
    id: '6',
    title: '',
    description: '',
    tags: [],
    mediaType: 'video',
    mediaUrl: 'https://i.imgur.com/pT4Yaq6.mp4',
    linkUrl: '#',
  },
  {
    id: '7',
    title: '',
    description: '',
    tags: [],
    mediaType: 'video',
    mediaUrl: 'https://i.imgur.com/yk2AxsJ.mp4',
    linkUrl: '#',
  },
  {
    id: '8',
    title: '',
    description: '',
    tags: [],
    mediaType: 'video',
    mediaUrl: 'https://i.imgur.com/EMFYkgw.mp4',
    linkUrl: '#',
  },
  {
    id: '9',
    title: '',
    description: '',
    tags: [],
    mediaType: 'video',
    mediaUrl: 'https://i.imgur.com/qid1xlx.mp4',
    linkUrl: '#',
  },
  {
    id: '10',
    title: '',
    description: '',
    tags: [],
    mediaType: 'video',
    mediaUrl: 'https://i.imgur.com/VAXilb4.mp4',
    linkUrl: '#',
  },
  {
    id: '11',
    title: '',
    description: '',
    tags: [],
    mediaType: 'video',
    mediaUrl: 'https://i.imgur.com/7VqFaQ8.mp4',
    linkUrl: '#',
  },
  {
    id: '12',
    title: '',
    description: '',
    tags: [],
    mediaType: 'video',
    mediaUrl: 'https://i.imgur.com/suLo1Ym.mp4',
    linkUrl: '#',
  },
  {
    id: '13',
    title: '',
    description: '',
    tags: [],
    mediaType: 'video',
    mediaUrl: 'https://i.imgur.com/scuPMf8.mp4',
    linkUrl: '#',
  },
];
